import { useEffect } from "react";
import CommonUtil from "../../utils/CommonUtil";

const AppUpgrade = props => {
    const userAgent = navigator.userAgent;
    const isAndroid = userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1;
    const storeUrl = !isAndroid ? 'itms-appss://apps.apple.com/cn/app/mology-cam/id6504283679' : 'https://oss-prod.moshontek.com/mology_cam/MologyCam1025.apk'
    window.location.href = storeUrl
    setTimeout(() => {
        if (!isAndroid) {
            if (CommonUtil.isInApp(navigator.userAgent)) {
                window.ReactNativeWebView.postMessage('exitWeb')
            }
        }
    }, 1000);

    const renderUpgradeView = () => {
        return <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
            <div style={{ color: '#333333', fontSize: 14, marginTop: 6, alignSelf: 'center' }}>APP已自动下载，请下拉手机在通知栏中安装</div>
            <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 25, marginRight: 25, marginTop: 30 }}>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <img alt="" style={{ width: 64, height: 64 }} src={`${CommonUtil.getSourceDomain()}download_app_icon.png`} />
                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 20 }}>
                        <div style={{ fontSize: 20, fontWeight: 'bold', color: '#000000' }}>Mology Cam</div>
                        <div style={{ fontSize: 16, marginTop: 15, color: '#000000' }}>版本: 1.3.5</div>
                    </div>
                </div>
                <div style={{ backgroundColor: '#F2F1F6', width: '100%', height: 64, borderRadius: 8, marginTop: 20, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ fontSize: 15, color: '#8A898E' }}>安卓已上线新版本</div>
                    <div style={{ fontSize: 13, color: '#007AFF', marginTop: 5, fontWeight: '500' }}>请在应用市场搜索 Mology Cam 下载APP</div>
                </div>
                <div style={{ marginTop: 30, fontSize: 18, fontWeight: 'bold', color: '#000000' }}>新功能</div>
                <div style={{ marginTop: 10 }}>
                    <div style={{ whiteSpace: 'pre-line', fontSize: 14, color: '#000000', lineHeight: 1.7 }}>{'1.看护功能共享升级，流程更顺畅；\n2.修复已知问题，提升稳定性'}</div>
                </div>
                <div style={{ backgroundColor: '#00000026', marginTop: 30, width: '100%', height: 0.5 }}></div>
                <div style={{ color: '#007AFF', fontSize: 14, marginTop: 20, fontWeight: '500' }}>注：新功能请务必先更新APP，再更新固件使用</div>
                <div style={{ marginTop: 30, fontSize: 14, fontWeight: 'bold', color: '#333333' }}>1.Magic3 设备开机</div>
                <div>
                    <img src={`${CommonUtil.getSourceDomain()}app_upgrade_open_device.png`} alt="" style={{ width: '100%', marginTop: 15 }} />
                </div>
                <div style={{ marginTop: 30, fontSize: 14, fontWeight: 'bold', color: '#333333' }}>2.Magic3 连接APP</div>
                <div>
                    <img src={`${CommonUtil.getSourceDomain()}app_upgrade_connect_device.png`} alt="" style={{ width: '100%', marginTop: 15 }} />
                </div>
                <div style={{ marginTop: 30, fontSize: 14, fontWeight: 'bold', color: '#333333' }}>3.按照提示务必点击固件更新</div>
                <div>
                    <img src={`${CommonUtil.getSourceDomain()}app_upgrade_firmware_upgrade.png`} alt="" style={{ width: '100%', marginTop: 15 }} />
                </div>
                <div style={{ height: 40 }} />
            </div>
        </div>
    }

    return <div className="App">
        {isAndroid ? renderUpgradeView() : null}
    </div>
}

export default AppUpgrade